import React from "react";
import { foodCalculators } from "./ConstantsFoodCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حواسب الطعام";
const DESCRIPTION = "استعرض جميع حواسب الطعام المتاحة للتحويل بين وحدات الطعام المختلفة. يمكنك ايضاً ايجاد حاسبة السعرات الحرارية، حاسبة البروتين، حاسبة الكربوهيدرات، حاسبة الدهون، حاسبة الماء، حاسبة الفيتامينات، حاسبة المعادن، حاسبة الألياف، حاسبة الكوليسترول، حاسبة السكر، حاسبة الصوديوم، حاسبة الكافيين، حاسبة الكحول، وغيرها من الحواسب المتعلقة بالطعام. كل حاسبة تحتوي على شرح مفصل لكيفية استخدامها، بالإضافة إلى أمثلة عملية لتسهيل فهمها. سواء كنت ترغب في حساب السعرات الحرارية لوجبتك، أو معرفة كمية البروتين التي تحتاجها يومياً، أو تحويل وحدات الطعام المختلفة، ستجد كل ذلك وأكثر في حواسب الطعام المتاحة لدينا.";
const KEYWORDS = "حواسب الطعام";
const OG_URL = 'https://do-calculate.com/ar/food-calculators/';
function CalculatorsList() {
  return (
    <div className="container rtl-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >الحاسبة</th>
            <th >الوصف</th>
          </tr>
        </thead>
        <tbody>
          {foodCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;
